import * as React from 'react';
import { useColorScheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import DarkModeIcon from '@mui/icons-material/DarkModeRounded';
import LightModeIcon from '@mui/icons-material/LightModeRounded';
import Box from '@mui/material/Box';

const ToggleContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '76px',
  height: '34px',
  borderRadius: '17px',
  padding: '1px',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  backgroundColor: theme.palette.mode === 'light' 
    ? 'rgba(0, 0, 0, 0.04)'
    : 'rgba(255, 255, 255, 0.04)',
  border: `1px solid ${theme.palette.mode === 'light' 
    ? 'rgba(0, 0, 0, 0.1)' 
    : 'rgba(255, 255, 255, 0.1)'}`,
  '&:hover': {
    backgroundColor: theme.palette.mode === 'light'
      ? 'rgba(0, 0, 0, 0.08)'
      : 'rgba(255, 255, 255, 0.08)',
  }
}));

const ToggleButton = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: '30px',
  height: '30px',
  borderRadius: '50%',
  backgroundColor: theme.palette.mode === 'light' 
    ? '#ffffff'
    : 'rgba(255, 255, 255, 0.1)',
  transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  left: theme.palette.mode === 'light' ? '1px' : 'calc(100% - 33px)',
  top: '1px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${theme.palette.mode === 'light'
    ? 'rgba(0, 0, 0, 0.1)'
    : 'rgba(255, 255, 255, 0.2)'}`,
  '& svg': {
    fontSize: '18px',
    color: theme.palette.mode === 'light' ? '#ffd700' : '#ffffff',
    transition: 'transform 0.3s ease',
    transform: theme.palette.mode === 'light' ? 'rotate(0deg)' : 'rotate(360deg)',
    position: 'relative',
    top: '1px',
  },
}));

const ModeText = styled('span')(({ theme }) => ({
  position: 'absolute',
  right: theme.palette.mode === 'light' ? '8px' : 'auto',
  left: theme.palette.mode === 'light' ? 'auto' : '8px',
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: '10px',
  fontWeight: 'normal',
  color: theme.palette.mode === 'light' 
    ? 'rgba(0, 0, 0, 0.6)'
    : 'rgba(255, 255, 255, 0.6)',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  userSelect: 'none',
}));

export default function ColorModeSelect(props) {
  const { mode, setMode } = useColorScheme();

  const toggleMode = () => {
    setMode(mode === 'light' ? 'dark' : 'light');
  };

  return (
    <Box {...props}>
      <ToggleContainer onClick={toggleMode} role="button" aria-label="Toggle color mode">
        <ToggleButton>
          {mode === 'light' ? <LightModeIcon /> : <DarkModeIcon />}
        </ToggleButton>
        <ModeText>
          {mode === 'light' ? 'Light' : 'Dark'}
        </ModeText>
      </ToggleContainer>
    </Box>
  );
}
